import { c } from "react-compiler-runtime";
import { StorageAPI } from "@graphiql/toolkit";
import { useEffect } from "react";
import { useStore, createStore } from "zustand";
const storageStore = createStore(() => ({
  storage: null
}));
const StorageContextProvider = (t0) => {
  const $ = c(3);
  const {
    storage,
    children
  } = t0;
  const $storage = useStorage();
  let t1;
  let t2;
  if ($[0] !== storage) {
    t1 = () => {
      storageStore.setState({
        storage: new StorageAPI(storage)
      });
    };
    t2 = [storage];
    $[0] = storage;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return $storage && children;
};
function useStorage() {
  return useStore(storageStore, _temp);
}
function _temp(state) {
  return state.storage;
}
export {
  StorageContextProvider,
  storageStore,
  useStorage
};
//# sourceMappingURL=storage.js.map
